import React, { Fragment } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, dateFormation, convertTypeString, convertClass, convertMinigameName } from '../../../common/cores';


const MinigameHistory = (props) => {
    
    console.log(props);

    const { history, page, index } = props

    return (
        <Fragment key={index}>
            <tr key={index}>
                <td className="bet_history_td" >{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>
                <td data-v-9dbb6d4c className="bet_history_td">
                {convertMinigameName(history.gameType)}
                </td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history) ? '' : history.round}</td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history.odd) ? '' : `${history.odd.name} (${Number(history.odd.rate).toFixed(2)})`}</td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history) ? '' : dateFormation(history.created_date, 1)}</td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history.balance) ? '' : Number(history.balance.bet).toLocaleString()}</td>
                <td data-v-9dbb6d4c className="bet_history_td">{isEmpty(history.balance) ? '' : Number(history.balance.win).toLocaleString()}</td>
                <td data-v-9dbb6d4c className={`bet_history_td ${convertClass(history.type)}`}>{convertTypeString(history.type)}</td>
            </tr>
        </Fragment>
    )
}

export default MinigameHistory;


// WEBPACK FOOTER //
// ./src/components/account/hisotries/MInigameHistory.js